import React, { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import styles from './styles.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Button from '../Button';
import Checkbox from '../CheckBox';
const ForwardMessages = forwardRef(({},ref) => {
  const { privateUsers, content, forwardMessages, setForwardMessages } =
    useContext(AdminContext);
  const forwardModalRef=useRef();
  const [users, setUsers] = useState([]);
  const clickFunction = (user) => {
    let index = users?.findIndex((x) => x.id == user?.id);
    if (index == -1) {
      setUsers([...users, user]);
    } else {
      setUsers([...users?.filter((x) => x.id != user?.id)]);
    }
  };
  
  const checkIfClickedOut = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      forwardModalRef &&
      forwardModalRef.current &&
      !forwardModalRef.current.contains(e.target)
    ) {
      setForwardMessages();
      setUsers([]);
      console.log('firstdepen');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOut);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOut);
    };
  }, [forwardMessages]);
  const submitFunction=()=>{
    let uuidUsers=[];
    users?.map((d) => {
      uuidUsers=[...uuidUsers, d?.users?.[0]?.channelUser?.uuid]
    })
    let chatIds=[];
    forwardMessages?.map((d) => {
      chatIds=[...chatIds, d?.id]})
 console.log("value====", uuidUsers, chatIds)
    ref.current.emit('private:forwardMessage', {uuidUsers:uuidUsers,chatIds:chatIds});
    setForwardMessages();
    setUsers([]);
  }
  console.log("users==", users, forwardMessages)
  return (
    <div className={`${styles.containerWrapper}`} ref={forwardModalRef}>
      <div className={`${styles.header} borderBottom`}>
        {content?.forwardHeader}
      </div>
      <div className={styles.container}>
        {privateUsers?.map((user, index) => (
          <div
            className={`flex flex-row justify-between items-center h-auto w-full my-[5px] cursor-pointer ${`userBoxStyle`} relative

              `}
            key={index}
            onClick={() => {
              clickFunction(user);
            }}
          >
            <div className={`flex flex-row justify-start items-start w-full`}>
              <Avatar
                width={24}
                height={24}
                containerclassName={`cursorDefault`}
                className={`cursorDefault`}
                src={
                  user?.users?.[0]?.channelUser?.image?.name
                    ? user?.users?.[0]?.channelUser?.image?.name
                    : blanckUser
                }
                local={!user?.users?.[0]?.channelUser?.image?.name}
              />
              <p className={`text-right ${styles.userText}`}>
                {user?.users?.[0]?.channelUser?.channelName
                  ? user?.users?.[0]?.channelUser?.channelName
                  : user?.users?.[0]?.channelUser?.username}
              </p>
            </div>
            <Checkbox
              className="mb-[22px]"
              checked={
                users?.findIndex((x) => x.id == user?.id) != -1 ? true : false
              }
              // onChange={() => handleCheckbox(contact, index)}
              onClick={(e) => {
                e.preventDefault();
                clickFunction(user);
              }}
            />
          </div>
        ))}
      </div>
      <Button
        onClick={() => {
          if (Object.keys(forwardMessages)?.length > 0) {
            submitFunction();
          }
        }}
        className={`sendBtn ${styles.button} flex flex-row justify-center items-center mx-auto`}
      >
        {content?.chatPage?.footer?.sendButton}
      </Button>
    </div>
  );
});
export default ForwardMessages;
